import {apiRetrieveImproved} from "@/api.ts";
import ClubProfile from "@/profile/ClubProfile.tsx";
import CommunityProfile from "@/profile/CommunityProfile.tsx";
import {PublicClubProfile, PublicCommunityProfile} from "@/types";
import queryKeys from "@/utilities/queryKeys.ts";
import {useQuery} from "@tanstack/react-query";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";
import CommunitiesView from "../../../../players/CommunitiesView.tsx";

export const Route = createFileRoute('/_app/communities/$community_uid/')({
    validateSearch: (search: Record<string, unknown>) => ({
        modal: search.modal as string | undefined,
    }),
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});

    const profileQuery = useQuery<PublicCommunityProfile>({
        queryKey: queryKeys.profile(params.community_uid!),
        queryFn:  async () => apiRetrieveImproved('public-community-profile' as any, {community_uid: params.community_uid}),
        enabled:  !!params.community_uid,
    })

    if (params.community_uid) {
        return <CommunityProfile profile={profileQuery.data} />
    }

    return <CommunitiesView />
}
